// src/context/AuthContext.jsx
import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [adminData, setAdminData] = useState(null);

  useEffect(() => {
    loadUserData();
  }, []);

  const loadUserData = async () => {
    try {
      const userData = localStorage.getItem('userData');
      const permissionsStr = localStorage.getItem('userPermissions');
      
      console.log("📋 Loading from storage - userData:", userData);
      console.log("📋 Loading from storage - permissionsStr:", permissionsStr);
      
      if (userData) {
        const parsed = JSON.parse(userData);
        
        console.log("📋 Parsed userData:", parsed);
        
        // ✅ FIXED: Properly extract permissions
        const admin = parsed.admin || parsed;
        const roleData = parsed.role || admin?.role || null;
        
        // ✅ GET PERMISSIONS FROM MULTIPLE SOURCES
        let perms = [];
        
        // Source 1: Direct permissions array
        if (parsed.permissions && Array.isArray(parsed.permissions)) {
          perms = parsed.permissions;
        }
        // Source 2: From role object
        else if (roleData?.permissions && Array.isArray(roleData.permissions)) {
          perms = roleData.permissions;
        }
        // Source 3: From localStorage
        else if (permissionsStr) {
          try {
            const parsedPerms = JSON.parse(permissionsStr);
            if (Array.isArray(parsedPerms)) {
              perms = parsedPerms;
            }
          } catch (e) {
            console.error("Error parsing permissions:", e);
          }
        }
        
        console.log("📋 Extracted Admin:", admin);
        console.log("📋 Extracted Role:", roleData);
        console.log("📋 Extracted Permissions:", perms);
        console.log("📋 Permissions Count:", perms.length);
        
        // ✅ SET ALL DATA
        setAdminData(admin);
        setUser(admin);
        setRole(roleData);
        setPermissions(perms);
        
        // ✅ Also save permissions separately
        localStorage.setItem('userPermissions', JSON.stringify(perms));
        
        console.log("✅ Auth loaded - User:", admin?.name, "Role:", roleData?.role_name, "Permissions:", perms.length);
      }
    } catch (error) {
      console.error('Error loading user data:', error);
    } finally {
      setLoading(false);
    }
  };

  const login = async (userData) => {
    try {
      // console.log("🔍 Login - Received userData:", userData);
      
      // // ✅ EXTRACT DATA
      // const admin = userData?.admin || userData?.user || userData;
      // const roleData = userData?.role || admin?.role || null;
      // const perms = userData?.permissions || roleData?.permissions || [];
      
      // console.log("📋 Login - Admin:", admin?.name);
      // console.log("📋 Login - Role:", roleData?.role_name);
      // console.log("📋 Login - Permissions:", perms);
      // console.log("📋 Login - Permissions Count:", perms.length);
      
      // // ✅ STORE IN STATE
      // setAdminData(admin);
      // setUser(admin);
      // setRole(roleData);
      // setPermissions(perms);
      
      // // ✅ STORE IN LOCALSTORAGE
      // localStorage.setItem('userData', JSON.stringify(userData));
      // localStorage.setItem('userPermissions', JSON.stringify(perms));
      
      // console.log("✅ Login successful!");
      // console.log("📋 User:", admin?.name);
      // console.log("📋 Role:", roleData?.role_name);
      // console.log("📋 Permissions count:", perms.length);
      
      return true;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('userData');
    localStorage.removeItem('userPermissions');
    localStorage.removeItem('Token');
    setAdminData(null);
    setUser(null);
    setRole(null);
    setPermissions([]);
    console.log("✅ Logged out");
  };

  const hasPermission = (permission) => {
    if (!permission) return true;
    
    // Super Admin has all permissions
    if (role?.role_name === 'Super Admin') return true;
    
    // Check if user has the specific permission
    const has = Array.isArray(permissions) && permissions.includes(permission);
    
    // Debug log
    if (process.env.NODE_ENV === 'development') {
      console.log(`🔍 hasPermission('${permission}'): ${has ? '✅' : '❌'}`);
    }
    
    return has;
  };

  const hasAnyPermission = (permissionList) => {
    if (!permissionList || permissionList.length === 0) return true;
    return permissionList.some(p => hasPermission(p));
  };

  const hasAllPermissions = (permissionList) => {
    if (!permissionList || permissionList.length === 0) return true;
    return permissionList.every(p => hasPermission(p));
  };

  const value = {
    user,
    role,
    permissions,
    loading,
    adminData,
    login,
    logout,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isSuperAdmin: role?.role_name === 'Super Admin',
    roleName: role?.role_name || 'No Role',
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
